<template>
  <tbody class="table__body">
    <tr
      v-for="(item, index) in items"
      :key="`line-${index}`"
      :class="[
        { 'table__body__tr--active': isActiveTableLine(item.id) || selectedSingleLine === item.id  },
        { 'cursor--pointer': lineClick  }
      ]"
    >
      <td
        v-if="checkbox || dropdownMenu.length"
        class="table__body__td--actions"
      >
        <v-checkbox
          v-if="checkbox"
          v-model="idsList"
          :value="item.id"
          :disabled="!selectedCompany"
          color="primary"
          hide-details
        />

        <v-menu
          v-if="dropdownMenu.length"
          offset-y
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn--more_vertical"
              icon
            >
              <v-icon color="gray-6">more_vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <div v-for="dropdownItem in dropdownMenu" :key="dropdownItem.text">
              <v-list-item
                v-show="dropdownItem.visible && !dropdownItem.divider"
                @click="dropdownItem.action(item)"
              >
                <v-list-item-title>{{ dropdownItem.text }}</v-list-item-title>
              </v-list-item>

              <v-divider v-if="dropdownItem.visible && dropdownItem.divider" />
            </div>
          </v-list>
        </v-menu>
      </td>

      <td
        v-for="(key, i) in item"
        :key="`${key}-${i}`"
        @click="lineClick && handleClick(item)"
      >
        <span v-if="key" v-html="key" :title="key" />
        <span v-else>-</span>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TBody',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    lineClick: {
      type: [Function, Boolean],
      default: false
    },
    selectedAllLines: {
      type: Boolean,
      default: false
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    dropdownMenu: {
      type: Array,
      default: () => []
    },
    activeLine: {
      type: [String, Number],
      default: null
    },
    clearSelectedLines: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      idsList: [],
      selectedSingleLine: null
    }
  },
  methods: {
    handleClick (item) {
      this.$emit('lineClick', this.lineClick(item))
      this.$emit('handleActiveLine', item)
    },

    isActiveTableLine (id) {
      return this.idsList.find(item => item === id)
    },

    upadteIdsList () {
      this.$emit('updateCheckbox', this.idsList)
    },

    handleSelectedAllLines (boolean) {
      if (boolean) {
        return this.updateIdsList(this.items.map(item => item.id))
      }

      if (this.items.length === this.idsList.length) {
        this.updateIdsList()
      }
    },

    updateIdsList (array = []) {
      this.idsList = [].concat(array)
    },

    clearIdsList () {
      this.idsList = []
    },

    handleSelectedSingleLine (id) {
      this.selectedSingleLine = id
    },

    enabledSelectedAllLinesCheckbox () {
      const boolean = this.items.length === this.idsList.length
      this.$emit('selectedAllLinesCheckbox', boolean)
    }
  },
  watch: {
    idsList (val) {
      this.upadteIdsList()
      this.enabledSelectedAllLinesCheckbox()
    },

    selectedAllLines (boolean) {
      this.handleSelectedAllLines(boolean)
    },

    activeLine (id) {
      this.handleSelectedSingleLine(id)
    },

    clearSelectedLines () {
      this.clearIdsList()
    }
  },
  mounted () {
    this.handleSelectedSingleLine(this.activeLine)
  }
}
</script>

<style lang="scss" scoped>
.table__body {

  tr {
    background-color: $white;
    border-bottom: 1px solid $gray-3;
    height: 60px;

    &.table__body__tr--active {

      &:nth-of-type(odd) {
        background-color: $attention;
      }

      &:nth-of-type(even) {
        background-color: darken($attention, 2);
      }

      &:hover {
        background-color: darken($attention, 4);
      }
    }
  }

  th, td {
    color: var(--gray-7);
    padding: 8px 16px;
    text-align: left;

    &:not(.table__body__td--actions) {
      white-space: nowrap;

      @media (min-width: 1200px) {
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.table__body__td--actions {

  > .v-input,
  > .v-btn {
    display: inline-table;
    vertical-align: middle;
  }

  > .v-input {
    margin: 0;
    padding: 0;
  }

  > .v-btn {
    overflow: hidden;

    .v-icon {
      display: inline-block;
    }
  }
}
</style>
